import { render, staticRenderFns } from "./TestUse.vue?vue&type=template&id=f56ab1b0&scoped=true&"
import script from "./TestUse.vue?vue&type=script&lang=js&"
export * from "./TestUse.vue?vue&type=script&lang=js&"
import style0 from "./TestUse.vue?vue&type=style&index=0&id=f56ab1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56ab1b0",
  null
  
)

export default component.exports